// extracted by mini-css-extract-plugin
export default {"skleton":"folderLoading_skleton__TAFcp","paragraph":"folderLoading_paragraph__bGFMz"};